import {apiRequest} from "./apiRequest";
import type {SentEmail} from "../types/sentEmail";

export async function getSentEmails(tenantId: string): Promise<SentEmail[]> {
  return apiRequest<SentEmail[]>({
    path: `admin/sent-emails?tenantId=${encodeURIComponent(tenantId)}`,
  });
}
